import React from "react";

import { useFeedContext } from "src/context/Feed";
import { BoxedSpinner } from "../BoxedSpinner";
import { FeedStackSectionProps } from "./types";
import { StackSection } from "@origin-digital/ods-core";

export function FeedStackSection<T = any>({
  renderContent,
  renderLoading = () => <BoxedSpinner />,
  "data-id": dataId = "feedStackSection",
}: FeedStackSectionProps<T>) {
  const { displayableStack, scrollableProps } = useFeedContext();

  React.useEffect(() => {
    window.addEventListener("scroll", scrollableProps.onWindowScroll);

    return () => {
      window.removeEventListener("scroll", scrollableProps.onWindowScroll);
    };
  }, []);
  return (
    <StackSection
      space="small"
      width="full"
      paddingY={"none"}
      hideGutter
      data-id={`${dataId}.root`}
    >
      {displayableStack.map((item, index) => {
        if (item.type === "content") {
          return renderContent(item.value as T, index);
        }
        return renderLoading();
      })}
    </StackSection>
  );
}
